import styled, { keyframes } from 'styled-components/macro'
import hexToRgba from 'hex-to-rgba'

const modalEnter = keyframes`
  from {
    background-color: ${hexToRgba('#000', 0)};
  }

  to {
    background-color: ${hexToRgba('#000', 0.3)};
  }
`

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${hexToRgba('#000', 0.3)};
  z-index: 100;
  animation: ${modalEnter} 250ms ease-in-out;
`

export default ModalWrapper
